import { Link, Navigate, createFileRoute } from "@tanstack/react-router";
import { BookOpenCheck, ClipboardCheck, Printer } from "lucide-react";
import guideHtml from "../content/global-admin-onboarding-guide.html?raw";
import { AdminPageHeader } from "../components/admin/client-operations-shared";
import { useAuth } from "../stores/auth";

export const Route = createFileRoute("/admin/guide")({
  component: GlobalAdminGuidePage,
});

function GlobalAdminGuidePage() {
  const user = useAuth((state) => state.user);
  if (!user) return null;
  if (user.role !== "global_admin") return <Navigate to="/admin/users" replace />;

  return (
    <div className="space-y-5 print:space-y-3">
      <div className="print:hidden">
        <AdminPageHeader
          eyebrow="Global Admin playbook"
          title="Client contracting & onboarding guide"
          description="A practical operating guide for contract-first client setup, Paddle collection, first-time onboarding fees, reconciliation, and access activation."
          actions={(
            <>
              <Link
                to="/admin/onboarding-guide"
                className="inline-flex min-h-8 items-center gap-1.5 rounded-md border border-border bg-bg px-3 py-1.5 text-xs font-medium text-fg transition-colors hover:border-accent/50"
              >
                <ClipboardCheck size={13} aria-hidden="true" />
                Onboarding operator guide
              </Link>
              <button
                type="button"
                onClick={() => window.print()}
                className="inline-flex min-h-8 items-center gap-1.5 rounded-md border border-border bg-bg px-3 py-1.5 text-xs font-medium text-fg transition-colors hover:border-accent/50"
              >
                <Printer size={13} aria-hidden="true" />
                Print or save PDF
              </button>
            </>
          )}
        />
      </div>

      <header className="hidden border-b border-border pb-3 print:block">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-accent">
          <BookOpenCheck size={14} aria-hidden="true" />
          Cascena Global Admin playbook
        </div>
        <h1 className="mt-2 text-2xl font-semibold">Client contracting & onboarding guide</h1>
        <p className="mt-1 text-sm text-muted">Contract-first setup, Paddle collection, onboarding fees, reconciliation, and access activation.</p>
      </header>

      {/* This is a bundled, first-party HTML fragment. It contains no user or API data. */}
      <div className="ops-admin-guide" dangerouslySetInnerHTML={{ __html: guideHtml }} />
    </div>
  );
}
